import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gateway_general = _resolveComponent("gateway-general")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_gateway_general, {
      amount: _ctx.query.amount,
      settings: {
        fixedAmount: _ctx.query.fixedAmt,
        collector_id: _ctx.query.id,
        source: _ctx.query.name,
        displayPaymentMode: _ctx.query.qr,
        fetchMemberDetails: _ctx.query.fetchData,
      }
    }, null, 8, ["amount", "settings"])
  ]))
}